import { useAppDispatch } from 'appState/store'
import moment from 'moment'
import { useState } from 'react'
import { FaUndo } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'

import { updateCurrentFiles } from '../FileShareSlice'
import { FileShareTabType } from '../types/FileShareEnums'

export const FileShareRefresh = () => {
  const dispatch = useAppDispatch()
  const [time, setTime] = useState(
    moment(new Date()).format('MM/DD/YYYY') + ' at ' + moment(new Date()).format('hh:mm:ss A'),
  )
  const refreshTabs = () => {
    setTime(moment(new Date()).format('MM/DD/YYYY') + ' at ' + moment(new Date()).format('hh:mm:ss A'))
    dispatch(dispatch(updateCurrentFiles({ root: FileShareTabType.Files, refresh: true })))
  }
  return (
    <Div>
      <span>System status as of {time}</span>
      <Button type="button" variant="tertiary" radius="normal" size="small" onClick={() => refreshTabs()}>
        <FaUndo /> Refresh
      </Button>
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  float: right;
  span {
    white-space: nowrap;
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    ${({ theme }) => theme.typography.s.normal};
    margin-top: 0.5rem;
    margin-left: 20px;
  }
`
